//企业信息
import {validatenull} from '@/util/validate'
import {isIdCardNoValid} from '@/util/validateRules'

export function baseUnitOption() {
	return [
		{
			label: '',
			prop: 'type',
			display: false,
			row: false,
		},
		{
			label: '',
			prop: 'certType',
			display: false,
			row: false,
		},
		{
			label: '',
			prop: 'name',
			display: false,
			disabled: false,
			slot: true,
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '',
				//   trigger: ['blur', 'change']
				// }
			],
		},
		{
			label: '',
			prop: 'legalPerson',
			placeholder: '',
			display: false,
			disabled: false,
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '',
				//   trigger: ['blur', 'change']
				// }
			],
		},
		{
			label: '',
			prop: 'certNo',
			placeholder: '',
			display: false,
			disabled: false,
			row: false,
			rules: [
				// {
				//   required: true,
				//   validator: '',
				//   trigger: ['blur', 'change']
				// }
			],
		},
		{
			label: '',
			prop: 'legalPersonMobile',
			placeholder: '',
			display: false,
			disabled: false,
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '请输入 联系人手机号码',
				//   trigger: 'blur'
				// },
				// {
				//   required: true,
				//   validator: rule.validatorMobile,
				//   trigger: 'blur'
				// }
			],
		},
		{
			label: '',
			prop: 'idNo',
			display: false,
			row: false,
			placeholder: '',
			rules: [],
		},
		{
			label: '',
			type: 'cascader',
			prop: 'areaCode',
			row: false,
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicData: [],
			filterable: true,
			showAllLevels: true,
			display: false,
			disabled: false,
			dataType: 'string',
			emitPath: false,
			rules: [
				// {
				//   required: true,
				//   type: 'array',
				//   message: '请选择 所在地区',
				//   trigger: 'change'
				// }
			],
		},
		{
			label: '',
			prop: 'addr',
			placeholder: '',
			display: false,
			disabled: false,
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '请输入 详细地址',
				//   trigger: ['blur', 'change']
				// }
			],
		},
		{
			label: '',
			prop: 'email',
			placeholder: '',
			span: 12,
			display: false,
			disabled: false,
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '请输入 企业联系人邮箱',
				//   trigger: 'blur'
				// }
			],
		},
		{
			label: '所属行业',
			prop: 'industry',
			display: false,
			disabled: false,
			type: 'select',
			dicData: [],
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '请选择 所属行业',
				//   trigger: 'change'
				// }
			],
		},
		{
			//(comment :'企业类别\\n1-全民所有制企业,2-集体所有制企业3-联营企业,4-外资企业,5-私营企业,6-合资企业")
			label: '企业类别',
			prop: 'category',
			type: 'select',
			display: false,
			disabled: false,
			dicData: [],
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '请选择 企业类别',
				//   trigger: 'change'
				// }
			],
		},
		//关系 "投保操作人与投保人关系" 有就显示
		{
			label: '',
			prop: 'relationWithOperator',
			display: false,
			disabled: false,
			row: false,
			rules: [],
		},
		//关系"被保人与投保人关系" relationWithApplicant
		{
			label: '',
			prop: 'relationWithApplicant',
			display: false,
			disabled: false,
			row: false,
			rules: [],
		},
		//安泽
		{
			label: '注册资本(万)',
			prop: 'registerCapital',
			display: false,
			disabled: false,
			row: false,
			rules: [],
		},
		{
			label: '证件有效期类型',
			prop: 'termType',
			type: 'select',
			display: false,
			disabled: false,
			dicData: [],
			row: false,
			rules: [],
		},
		//证件有效期类型
		{
			label: '有效期起始日期',
			prop: 'termStart',
			display: false,
			disabled: false,
			type: 'datetime',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			format: 'yyyy-MM-dd HH:mm:ss',
			row: false,
			rules: [
				//   {
				//   required: true,
				//   message: '请选择 有效期起始日期'
				// }
			],
		},
		{
			label: '有效期终止日期',
			prop: 'termEnd',
			display: false,
			disabled: false,
			type: 'datetime',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			format: 'yyyy-MM-dd HH:mm:ss',
			row: false,
			rules: [
				//   {
				//   required: true,
				//   message: '请选择 有效期终止日期'
				// }
			],
		},
		{
			label: '经营范围',
			prop: 'businessScope',
			type: 'textarea',
			display: false,
			disabled: false,
			minRows: 2,
			maxRows: 3,
			row: false,
			rules: [
				//   {
				//   required: true,
				//   message: '请输入 经营范围'
				// }
			],
		},
		{
			label: '企业负责人身份证正面',
			prop: 'identityFront',
			type: 'upload',
			display: false,
			disabled: false,
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			row: false,
			rules: [
				//   {
				//   required: true,
				//   message: '请上传企业负责人身份证正面',
				//   trigger: 'blur'
				// }
			],
		},
		{
			label: '企业负责人身份证反面',
			prop: 'identityBack',
			type: 'upload',
			display: false,
			disabled: false,
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			row: false,
			rules: [
				//   {
				//   required: true,
				//   message: '请上传企业负责人身份证反面',
				//   trigger: 'blur'
				// }
			],
		},
		{
			label: '营业执照',
			prop: 'certImgFront',
			type: 'upload',
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			limit: 1,
			display: false,
			disabled: false,
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '请上传营业执照',
				//   trigger: 'blur'
				// }
			],
		},
		{
			label: '示例',
			prop: 'example1',
			type: 'upload',
			listType: 'picture-img',
			value: '',
			display: false,
			propsHttp: {
				res: 'data',
			},
			row: false,
			disabled: true,
		},
		{
			label: '营业执照（反面）',
			prop: 'certImgBack',
			type: 'upload',
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			limit: 1,
			display: false,
			disabled: false,
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过2Mb的jpg/png文件',
			row: false,
			rules: [
				// {
				//   required: true,
				//   message: '请上传营业执照',
				//   trigger: 'blur'
				// }
			],
		},
		{
			label: '示例',
			prop: 'example2',
			type: 'upload',
			listType: 'picture-img',
			value: '',
			display: false,
			propsHttp: {
				res: 'data',
			},
			row: false,
			disabled: true,
		},
	]
}

//处理unit option
export function getBaseUnitOption(reqUnitData, isPlan = false) {
	//获取外层基类
	let tempUnitOption = getTypeBaseForm()
	let tempColumn = baseUnitOption()
	for (let i = 0; i < tempColumn.length; i++) {
		let columnItem = tempColumn[i]
		let {prop = '', display = true} = columnItem
		//如果存在
		if (!validatenull(reqUnitData[prop])) {
			//处理如果是计划书则只显示企业名称和信用代码，地区
			if (isPlan) {
				const targetProps = ['name', 'certNo', 'areaCode', 'certImgFront', 'certType', ' type']
				if (targetProps.includes(prop)) {
					// 加入
					tempUnitOption.column.push(columnItem)
				}
			} else {
				//加入
				tempUnitOption.column.push(columnItem)
			}
			let {key = '', example = '', visible = 0} = reqUnitData[prop]
			//处理示例
			if ((key === 'certImgFront' || key === 'certImgBack') && visible === 1 && example !== '') {
				//有营业执照，则需要展示示例
				let tempExample = tempColumn[i + 1]
				tempExample.display = true
				tempExample.value = example
				tempUnitOption.column.push(tempExample)
			}
		}
	}
	return tempUnitOption
}

export function onSetLayout(UnitOption) {
	let showNum = 0
	let showLastIndex = 0
	UnitOption.column.forEach((itemData, index) => {
		//先初始化
		itemData.span = 12
		itemData.row = false
		let {prop, display = false, span = 12, row = false} = itemData
		//营业执照
		if ((prop === 'certImgFront' || prop === 'identityFront') && display) {
			let lastColumn = UnitOption.column[showLastIndex]
			if (showNum % 2 !== 0) {
				lastColumn.row = true
				lastColumn.span = 12
				showNum += 1
			} else {
				if (lastColumn.row) {
					lastColumn.row = false
					lastColumn.span = 12
				}
			}
		}
		if (display) {
			showNum += 1
			showLastIndex = index
		}
	})
}

//方案
export function basePlanOption(planFormData = {}, dutiesData = []) {
	//获取外层基类
	let tempData = getTypeBaseForm()
	let tempColumn = getTypeBaseColumn(planFormData, {span: 24})
	for (let dutiesDatum of dutiesData) {
		let {content = '', id = '', orderNum} = dutiesDatum
		if (id !== '') {
			tempColumn.push({
				label: content,
				prop: `item${id}`,
				disabled: true,
				row: true,
				span: 24,
				placeholder: ' ',
				display: true,
				orderNum,
				type: '',
				minRows: 3,
				maxRows: 5,
			})
		}
	}
	//排个序
	tempData.column = tempColumn.sort((a, b) => {
		return a.orderNum - b.orderNum
	})
	return tempData
}

//生效时间
export function basePeriodOption(periodFormData = {}, isAdd) {
	//获取外层基类
	let tempData = getTypeBaseForm()
	tempData.column = [
		{
			label: '当前日期',
			prop: 'today',
			span: 24,
			slot: true,
		},
		...getTypeBaseColumn(periodFormData, {span: 24}),
	]
	if (isAdd) {
		//批增
		tempData.column.push({
			label: '保障期限',
			prop: 'periodDay',
			span: 24,
			value: 0,
			slot: true,
		})
	}
	tempData.column.push({
		label: '保险止期',
		prop: 'expiryDate',
		span: 24,
		slot: true,
	})
	return tempData
}

//员工信息
export function baseEmployeeOption(EmpFormData = {}, isAddFee = true) {
	let tempData = {
		index: true,
		indexLabel: '序号',
		indexWidth: 70,
		border: true,
		stripe: true,
		addBtn: false,
		editBtn: false,
		delBtn: false,
		gridBtn: false,
		refreshBtn: false,
		columnBtn: false,
		saveBtn: false,
		cancelBtnText: '移除',
		align: 'center',
		header: true,
		menu: true,
		menuWidth: 160,
		rowKey: 'sn',
		column: [],
	}
	let tempColumn = getTypeBaseColumn(EmpFormData, {
		cell: true,
		minWidth: 120,
		hide: false,
	})
	//排序
	tempData.column = tempColumn.sort((a, b) => {
		return a.orderNum - b.orderNum
	})
	//增加保费
	if (isAddFee) {
		tempData.column.push({
			label: '保费（元）',
			prop: 'premium',
			fixed: 'right',
			disabled: true,
			orderNum: 99,
			width: 120,
			value: 0,
		})
	}
	return tempData
}

//盖章文件的option
export function baseFileConfirmOption(fileConfirmData) {
	//获取外层基类
	let tempOption = getTypeBaseForm()
	let tempColumn = getTypeBaseColumn(fileConfirmData)
	//处理其他
	tempColumn.push({
		label: '示例',
		prop: 'insureConfirmSample',
		span: 4,
		type: 'upload',
		listType: 'picture-img',
		propsHttp: {
			res: 'data',
		},
		disabled: true,
	})
	tempColumn.push({
		label: '',
		span: 2,
		prop: 'insureConfirmUrl',
	})
	tempOption.column = tempColumn
	return tempOption
}

//对公支付的option
export function baseOfflineOption(offlineFormData = {}) {
	//获取外层基类
	let tempOption = getTypeBaseForm()
	//特殊处理一下
	tempOption.submitText = '立即提交'
	tempOption.labelWidth = '120'
	let tempColumn = getTypeBaseColumn(offlineFormData)
	//还得处理一下
	tempColumn.forEach((itemData) => {
		let {prop = ''} = itemData
		if (prop !== 'file') {
			itemData.span = 24
		} else {
			itemData.span = 12
		}
	})
	//是否要加示例
	let {file: {example = ''} = {}} = offlineFormData
	if (example) {
		//处理其他
		tempColumn.push({
			label: '示例',
			prop: 'fileExample',
			value: example,
			span: 6,
			type: 'upload',
			listType: 'picture-img',
			propsHttp: {
				res: 'data',
			},
			disabled: true,
		})
	}

	//排个序
	tempOption.column = tempColumn.sort((a, b) => {
		return a.orderNum - b.orderNum
	})
	return tempOption
}

export function baseFileConfirmOptionAnZe(fileConfirmData) {
	//获取外层基类
	let tempOption = getTypeBaseForm()
	let tempColumn = getTypeBaseColumn(fileConfirmData)
	//批量多张
	tempColumn[0].listType = 'picture-card'
	tempColumn[0].multiple = true
	tempColumn[0].limit = 3
	tempColumn[0].dataType = 'string'
	tempColumn[0].separator = '@;@'

	//处理其他
	tempColumn.push({
		label: '扫码下载盖章件',
		prop: 'insureConfirmSample',
		span: 4,
		type: 'upload',
		listType: 'picture-img',
		propsHttp: {
			res: 'data',
		},
		disabled: true,
	})
	tempColumn.push({
		label: '',
		span: 8,
		prop: 'insureConfirmUrl',
	})
	tempOption.column = tempColumn
	return tempOption
}

//泰康其他字段
export function baseProductInfoOption(tkOtherData = {}) {
	//获取外层基类
	let tempOption = getTypeBaseForm()
	let tempColumn = getTypeBaseColumn(tkOtherData)
	//还得处理一下
	tempColumn.forEach((itemData) => {
		itemData.span = 12
		//如果key为qualificationLevel type为qualificationLevel-select，则特殊处理请求
		if (itemData.prop === 'qualificationLevel') {
			let tempLevelData = {
				props: {
					label: 'label',
					value: 'key',
				},
				dicUrl: `/dist/bowei/object?path=/v2/dict/query`,
				dicMethod: 'post',
				dicQuery: {
					dictTypes: ['qual_level'],
				},
				dicFormatter: (resData = {}) => {
					let {code = 0, data = []} = resData
					if (code !== 0 || data.length <= 0) {
						return []
					}
					return data[0].data || []
				},
			}
			//合并
			Object.assign(itemData, tempLevelData)
		}
	})
	//排个序
	tempOption.column = tempColumn.sort((a, b) => {
		return a.orderNum - b.orderNum
	})
	return tempOption
}

//附件option
export function baseFileAttachOption(AttachData) {
	//获取外层基类
	let tempOption = getTypeBaseForm()
	let tempColumn = getTypeBaseColumn(AttachData)
	//需要特殊处理
	if (tempColumn.length > 0) {
		//需要特殊处理
		Object.assign(tempColumn[0], {
			accept: '',
			listType: 'text',
			multiple: true,
			limit: 10,
			fileSize: 5 * 1024,
			propsHttp: {
				res: 'data',
			},
			tip: '请上传大小不超过5Mb的文件，最多上传10张',
		})
	}
	//没有确认按钮
	tempOption.submitBtn = false
	tempOption.emptyBtn = false
	tempOption.column = tempColumn
	return tempOption
}

export function getBaseInvoiceOption(invoiceFormData) {
	//获取外层基类
	let tempOption = getTypeBaseForm()
	let tempColumn = getTypeBaseColumn(invoiceFormData)
	//处理排序问题
	tempColumn = tempColumn.sort((a, b) => a.orderNum - b.orderNum)
	//判断最后一个是不是上传文件
	if (tempColumn[tempColumn.length - 1].listType === 'picture-img') {
		tempColumn.push({
			label: '截图示例',
			prop: 'example1',
			display: false,
			formslot: true,
			orderNum: 10001,
		})
	}
	//地址 默认是全部选择的
	tempColumn.forEach((itemData) => {
		let {prop = ''} = itemData
		if (prop === 'mailAreaCode') {
			delete itemData.dataType
			delete itemData.emitPath
		}
	})
	tempOption.column = tempColumn
	return tempOption
}

/**
 * 普通基类
 */
function getTypeBaseForm() {
	return {
		submitBtn: true,
		submitText: '确认',
		emptyBtn: false,
		menuBtn: true,
		labelWidth: 140,
		column: [],
	}
}

function getTypeBaseColumn(fromData = {}, otherData = {}) {
	let tempColumn = []
	for (let formKey in fromData) {
		if (formKey !== 'config') {
			tempColumn.push(getTypeBaseItemNew(fromData[formKey], otherData))
		}
	}
	return tempColumn
}

/**
 * 普通基类item
 * @param itemData
 * @param otherData 特殊的数据
 */
function getTypeBaseItemNew(itemData = {}, otherData = {}) {
	let {key = '', type = '', range = [], orderNum = 0} = itemData
	let tempData = {
		label: '',
		prop: key,
		dicData: [],
		rules: [],
		display: false,
		disabled: false,
		placeholder: '',
		orderNum,
		...otherData,
	}
	if (type === 'area-select' || type === 'qualificationLevel-select') {
		Object.assign(tempData, {
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicUrl: `/dist/area/list/3`,
			filterable: true,
			showAllLevels: true,
			display: false,
			disabled: false,
			dataType: 'string',
			emitPath: false,
		})
		//删除rules
		delete tempData.dicData
	} else if (type === 'upload') {
		Object.assign(tempData, {
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			limit: 1,
			dragFile: true,
			accept: 'image/png, image/jpeg',
			tip: '请上传大小不超过5Mb的jpg/png文件',
		})
	} else if (type === 'profession-select') {
		Object.assign(tempData, {
			props: {
				value: 'id',
				label: 'categoryName',
			},
			emitPath: false,
			dataType: 'string',
			filterable: true,
			expandTrigger: 'click',
		})
	} else if (type === 'date' || type === 'datetime') {
		let tempDate = {
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			expandTrigger: 'click',
		}
		if (range.length > 0) {
			Object.assign(tempDate, {
				range,
				pickerOptions: {
					disabledDate: (time) => {
						//禁止投保时间
						return (
							time.getTime() < new Date(`${range[0]} 00:00:00`).getTime() ||
							time.getTime() > new Date(`${range[1]} 23:59:59`).getTime()
						)
					},
				},
			})
		}
		//如果是保单起期，则需要设置可选时间
		Object.assign(tempData, tempDate)
	}
	return tempData
}

//获取完整的option
export function getCompleteOption(reqData, tempOption) {
	tempOption.column.forEach((itemData, index) => {
		let {prop = ''} = itemData
		//如果存在
		if (!validatenull(reqData[prop])) {
			let {
				key = '',
				label = '',
				placeholder = '',
				required = 0,
				disabled = 0,
				visible = 0,
				visibleConditions = [],
				defaultValue = '',
				type: itemType = '',
				verifies = [],
				options = [],
				example = '',
			} = reqData[prop]
			itemData.label = label
			itemData.placeholder = placeholder
			itemData.display = visible === 1 && visibleConditions.length <= 0
			itemData.hide = visible !== 1
			itemData.disabled = disabled === 1
			itemData.type =
				itemType === 'area-select' || itemType === 'profession-select' || itemType === 'qualificationLevel-select'
					? 'cascader'
					: itemType
			//可清空
			itemData.clearable = itemType === 'input'
			//选项
			if (options.length > 0) {
				options = options.filter(({value = ''}) => value)
				itemData.dicData = options
			}
			if (!validatenull(defaultValue)) {
				itemData.value = defaultValue
			}
			//需要限制项目
			if (verifies.length > 0 && itemData.rules) {
				//是否是身份证校验
				let isHasIdNo = verifies.find(({matchType}) => matchType === 20)
				//身份证！！校验比较特殊！！需要单独写
				if (isHasIdNo) {
					itemData.rules.push({
						required: true,
						message: '请输入身份证号',
						trigger: 'blur',
					})
					//查找最小值，最大值
					let minData = verifies.find(({matchType}) => matchType === 22)
					let maxData = verifies.find(({matchType}) => matchType === 21)

					itemData.rules.push({
						required: true,
						validator: (rule, value = '', callback) => {
							if (value === '') {
								callback()
							} else {
								if (!isIdCardNoValid(value + '')) {
									callback(new Error('请输入正确的身份证号'))
								} else {
									if (!validatenull(minData) && !validatenull(maxData)) {
										let minNum = parseInt(minData.value)
										let maxNum = parseInt(maxData.value)
										let myDate = new Date()
										let month = myDate.getMonth() + 1
										let day = myDate.getDate()
										let age = myDate.getFullYear() - parseInt(value.substring(6, 10)) - 1
										let chaMonth = parseInt(value.substring(10, 12))
										if (chaMonth < month || (chaMonth === month && parseInt(value.substring(12, 14)) <= day)) {
											age++
										}
										//通过身份证获取年龄信息！
										// let tempNum = getAgeByCardNo('110101198603070096')
										if (age < minNum || age > maxNum) {
											callback(new Error(minData.errorMsg))
										}
									}

									callback()
								}
							}
						},
						trigger: 'blur',
					})
				} else {
					let zhengzeList = []
					for (const verifiesKey of verifies) {
						let {errorMsg = '未知错误！！', type = -1, matchType = -1, value: valueVer = ''} = verifiesKey
						//校验
						if (matchType === 2 && valueVer !== '') {
							//存在正则，需要循环处理
							zhengzeList.push({valueVer, errorMsg})
						} else if (matchType === 20) {
							//默认身份证
						} else {
							if (type === 1) {
								//必填
								itemData.rules.push({
									required: true,
									message: errorMsg,
									trigger: !itemType || itemType === 'input' || itemType === 'number' ? 'blur' : ['blur', 'change'],
								})
							} else if (type !== -1) {
								itemData.rules.push({
									validator: (rule, value, callback) => {
										//正则
										if (valueVer === '') {
											callback()
										} else {
											/*
                       *     NOT_NULL(1, "非空判断"),
                       PATTERN(2, "正则判断"),
                       GT(3, "大于"),
                       GE(4, "大于等于"),
                       LT(5, "小于"),
                       LE(6, "小于等于"),
                       PROTOCOL_IDENTITY_NO(20, "（约定）身份证校验"),
                       PROTOCOL_IDENTITY_MAX_AGE(21, "（约定）最大年龄"),
                       PROTOCOL_IDENTITY_MIN_AGE(22, "（约定）最小年龄"),
                       AREA_STRUCT(23, "地区过滤结构化处理")*/
											//正则  ^\\d{2}(4406)
											if (
												(matchType === 3 && value.length <= parseInt(valueVer)) ||
												(matchType === 4 && value.length < parseInt(valueVer)) ||
												(matchType === 5 && value.length >= parseInt(valueVer)) ||
												(matchType === 6 && value.length !== parseInt(valueVer))
											) {
												callback(new Error(errorMsg))
											} else {
												callback()
											}
										}
									},
									trigger: 'blur',
								})
							}
						}
					}
					//处理正则
					if (zhengzeList.length > 0) {
						itemData.rules.push({
							validator: (rule, value = '', callback) => {
								if (value === '') {
									callback()
								} else {
									//判断
									let tempData = zhengzeList.find(({valueVer, errorMsg}) => !new RegExp(valueVer).test(value))
									if (validatenull(tempData)) {
										callback()
									} else {
										callback(new Error(tempData.errorMsg))
									}
								}
							},
							trigger: 'blur',
						})
					}
				}
			}
		}
	})

	return tempOption
}
